import { matchPath } from 'react-router';

import { Category } from 'common/selectors/sidebar/utils';

const getDefaultActiveGroup = (
  pathname: string,
  sidebarStructure: Category[],
) => {
  for (let groupIndex = 0; groupIndex < sidebarStructure.length; groupIndex++) {
    const { sections, path, title } = sidebarStructure[groupIndex];

    for (let pathIndex = 0; pathIndex < sections.length; pathIndex++) {
      if (path && matchPath(pathname, sections[pathIndex].path)) {
        return { path, title };
      }
    }
  }
  const [firstCategory] = sidebarStructure;

  return { path: firstCategory?.path || '', title: firstCategory?.title || '' };
};

export default getDefaultActiveGroup;
